export class StorageEnums {
    public static readonly storageProductTypeValues: Array<StorageProductType> =
        ['SBU', 'STORAGE_VOLUME', 'INJECTION_CAPACITY', 'WITHDRAWAL_CAPACITY'];
    public static readonly storageQuantityUnitValues: Array<StorageQuantityUnit> =
        ['SBU', 'KWH', 'KWH_H', 'KWH_D', 'M3', 'M3_H'];
    public static readonly storageQuantityUnitValuesHourDay: Array<StorageQuantityUnit> =
        ['KWH_H', 'KWH_D', 'M3_H'];
    public static readonly storageQuantityUnitValuesKwh: Array<StorageQuantityUnit> =
        ['KWH', 'M3'];
    public static readonly allocationMethodValues: Array<AllocationMethod> = [
        'NO_ALLOCATION',
        'NO_ALLOCATION_2_BIDDING_ROUNDS',
        'PAY_AS_BID',
        'UNIFORM_PRICE',
        'UNIFORM_PRICE_MATCHING'
    ];
    public static readonly storageCurrencyValues: Array<StorageCurrency> = [
        'CENT',
        'EURO'
    ];
    public static readonly storageCapacityCategoryValues: Array<StorageCapacityCategory> =
        ['FIRM', 'INTERRUPTIBLE'];
    public static readonly storagePriceRuntimeValues: Array<StoragePriceRuntime> =
        ['RUNTIME', 'HOUR', 'DAY', 'MONTH', 'YEAR'];
    public static readonly storageProductPeriods: Array<StoragePeriodType> = [
        'WITHINDAY',
        'DAY',
        'WEEK',
        'MONTH',
        'YEAR'
    ];
}
